import React from "react";

class ContentNinja extends React.Component{

	render(){
		return (
			<div className="container" style={{fontSize:15,textAlign: "justify"}}>
				<center>
					<img src="https://floorwalk-client-logos.s3.ap-south-1.amazonaws.com/LOGOS/content_ninja_logo.png" style={{margin:"20px 0px",width:"35%"}} />
					<p><b>Flexible, work-from-home content writing opportunity!</b></p>
				</center>
				<br/>
				<p>We are a content marketing company based out of Gurgaon and are looking to hire 50+ content writing professionals who can work from home for 4-8 hours a day, flexibly.</p>
				<p>We will give the article brief and guidelines, and expect 1500-3000 words per day from the writers. Once the articles are approved, the freelancers can submit an invoice by the 14th of every month, which will be cleared by the 15th by our finance team.</p>
				<p>People can easily earn INR 20,000 - 40,000 per month by working flexibly (morning, evening, or midnight). All we care about is you submit the articles on time.</p>
				<br/><p><b>Application Guidelines:</b></p>
				<ol style={{listStyleType: "decimal"}}>
					<li style={{padding: "5px 0px"}}>Please send us a sample article in a Google Doc format using these guidelines on <a href="mailto:shriya@contentninja.in">shriya@contentninja.in</a></li>
				</ol>
				<br/>
				<p>Guidelines:</p>
				<br/><p><b>Client</b>: <a href="http://www.outsons.com" target="_blank" rel="noopener noreferrer" style={{textDecoration:"none"}}>Outsons.com</a></p>
				<p><b>Reference articles:</b></p>
				<p><a href="https://outsons.com/best-butterfly-tattoo-small-ideas-youll-have-to-see-to-believe/" target="_blank" rel="noopener noreferrer">https://outsons.com/best-butterfly-tattoo-small-ideas-youll-have-to-see-to-believe/</a></p>
				<p><a href="https://outsons.com/best-deadpool-tattoo-ideas-youll-have-to-see-to-believe/" target="_blank" rel="noopener noreferrer">https://outsons.com/best-deadpool-tattoo-ideas-youll-have-to-see-to-believe/</a></p>
				<br/><p>Outsons is a men’s (and women’s) styling website.</p>
				<p>While the website focuses on styling, grooming, and fashion tips including suggestions for tattoos. It is a UK-based website and the target audience is 30-45 year old.</p>
				<p>Our work is primarily focused on finding the right tattoos based on the given theme and providing a unique description of the same tattoo such that it creates a vivid impression in the mind of the reader. More on the stylistics later.</p>
				<p>Let’s jump into the basics first: </p>
				<br/><p><b>Title for Sample:</b></p>
				<p>10 Best Penguin Tattoo Ideas You Have To See To Believe!</p>
				<p>Word Length: ~1500 words</p>
				<p>English Style: <b>British English</b></p>
				<ul>
					<li style={{marginBottom:"10px"}}>The intro should be broken into 3 parts - 1 sentence, para break, 2 sentences, para break - rest of the intro. For reference, you can check the intro format under guidelines.</li>
					<li style={{marginBottom:"10px"}}>
						<p>Each subheading needs a picture to go with it. Use Instagram ONLY for images. NEVER use images from a company (such as Getty) that require payment.<br/></p>
						<p>Example:<br /></p>
						<p>For a theme, DBZ tattoos, we chose this tattoo:</p>
						<img src="https://floorwalk-client-logos.s3.ap-south-1.amazonaws.com/extra/content_ninja3.png" className="img-thumbnail" />
						<br/><br/><p>This was the subheading given (based on the tattoo selected):</p>
						<img src="https://floorwalk-client-logos.s3.ap-south-1.amazonaws.com/extra/content_ninja1.png" className="img-responsive" />
						<p>And the rest of the description focuses on the tattoo and theme.</p>
					</li>
					<li style={{marginBottom:"10px"}}>
						<b>Number of Subheadings:</b> There should be 10 subheadings - each having different tattoos. Since we have to give 10 choices as per the topic, we need to give 10 subheadings or choices.
					</li>
					<li style={{marginBottom:"10px"}}>
						<b>Searching Instagram images:</b> When looking for images on Instagram, search #(themetattoo). For example, with DBZ tattoo, we searched using #dbztattoo. Once you get a list of tattoos, try opting for tattoos with higher likes.
					</li>
					<li style={{marginBottom:"10px"}}>
						<b>Adding Instagram links:</b> As you may have spotted on the screenshot, an Instagram link and credit is a must after each subheading. Credit should be added as (Image Credit: @username via Instagram).
					</li>
					<li style={{marginBottom:"10px"}}>
						<p>
							<b>Add a conclusion at the end of each piece.</b> This should be a digestible paragraph or numbered list that adds more suggestions (without the Instagram link or description). Essentially, it makes your article stand out and enriches the reader with more choices.<br/>Example:
						</p>
						<img src="https://floorwalk-client-logos.s3.ap-south-1.amazonaws.com/extra/content_ninja2.png" className="img-responsive" />
					</li>
					<li style={{marginBottom:"10px"}}>
						Always ensure that your <b>word count is as close to the limit as possible,</b> without going over. You won’t be paid for any additional words so bear that in mind.
					</li>
					<li style={{marginBottom:"10px"}}>
						Add a plagiarism-free screenshot at the end using SmallSEOtools
					</li>
					<li style={{marginBottom:"10px"}}>
						Re-read the article to make sure it’s free of grammatical errors. You can also run it through a tool like Grammarly
					</li>
				</ul>
				<br/>
				<p><b>Stylistics:</b></p>
				<p>Outsons is a creative project and impactful language makes or breaks the article. Words hurt or heal - but most importantly, words can sell. So, it’s important to ‘speak’ to the reader, enrich their mind and make an impression with the article that resonates with the reader, the theme and the general industry. Here are some pointers:</p>
				<ul>
					<li style={{marginBottom:"10px"}}>
						Do not stray from the topic. The focus of the topic is tattoos. While small snippets of the symbolism of a specific tattoo theme can be used, ensure that the focus under each subheading is on the tattoo - the thick or thin strokes, how prominent the said tattoos looks, how it would appear to the world and how the tattoo art can create an impression. A rule of thumb is to write about the tattoo in a way that would make you want to have that tattoo on your body.
					</li>
					<li style={{marginBottom:"10px"}}>
						Imagination is important when it comes to writing. Always place yourself in the shoes of the reader and write for that reader. After writing and reading your own piece, think if you’d read the article if it popped up on your feed. If not, it’s not a good article.
					</li>
					<li style={{marginBottom:"10px"}}>
						Be precise with your words and sentences. Do not beat about the bush - ensure that each sentence has something meaningful to say and leads up to the next significant sentence. Fluff becomes way too prominent after some time <b>- not recommended.</b>
					</li>
					<li style={{marginBottom:"10px"}}>
						Be creative with subheadings. There might be similar images. You have to compare two images but make a kickass subheading so as to create a unique element of difference between the two.
					</li>
					<li style={{marginBottom:"10px"}}>
						Don’t use cuss words - they just make any piece immature.
					</li>
					<li style={{marginBottom:"10px"}}>
						If the sample is accepted, you will be paid at INR 50 paisa per word. For a 1500 word article, you will receive INR 750.
					</li>
					<li style={{marginBottom:"10px"}}>
						If you have a resume available, or any other content writing samples, please include them as well in your email.
					</li>
					<li style={{marginBottom:"10px"}}>
						For any queries, please write to us at <a href="mailto:shriya@contentninja.in">shriya@contentninja.in</a>
					</li>
				</ul>
				<br/>
				<p>We look forward to working with you!</p>
			</div>
		);
	}
}

export default ContentNinja;
